import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";
import {SemanticSearchPropertyDto} from "../types/SemanticSearchPropertyDto";

export const AI_ASSISTANT_AUTH_CUSTOM_LABEL = "ai_assistant";

type AiAssistantAction = "open" | "close";
type AiAssistantChatAction = "click" | "fill" | "submit";
type AiAssistantCtaAction = "click" | "view";
type AiAssistantOfferAction = "view" | "select";

const getPropertyCity = (property: SemanticSearchPropertyDto): string => {
    const stats = property.offer.region.stats;

    return stats?.region_type_city?.name || stats?.region_type_town?.name || "na";
};

export const hitAiAssistant = (eventAction: AiAssistantAction) => {
    hitGoogleTagManager({
        event: "ai_assistant",
        event_action: eventAction
    });
};

export const hitAiAssistantChat = (eventAction: AiAssistantChatAction) => {
    hitGoogleTagManager({
        event: "ai_assistant_chat",
        event_action: eventAction
    });
};

export const hitAiAssistantBadge = (eventLabel: string) => {
    hitGoogleTagManager({
        event: "ai_assistant_badge",
        event_action: "click",
        event_label: eventLabel
    });
};

export const hitAiAssistantOffer = (eventAction: AiAssistantOfferAction, property: SemanticSearchPropertyDto) => {
    hitGoogleTagManager({
        event: "ai_assistant_offer",
        event_action: eventAction,
        event_category: property.offer.vendor.name,
        event_category2: property.offer.name,
        event_category3: getPropertyCity(property)
    });
};

export const hitAiAssistantOffers = (eventLabel: string, regionIds: number[]) => {
    hitGoogleTagManager({
        event: "ai_assistant_offers",
        event_action: "click",
        event_label: eventLabel,
        event_category: regionIds
    });
};

export const hitAiAssistantCta = (eventAction: AiAssistantCtaAction, eventLabel: "Załóż konto" | "Zaloguj się") => {
    hitGoogleTagManager({
        event: "ai_assistant_cta",
        event_action: eventAction,
        event_label: eventLabel
    });
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";
import {SemanticSearchPropertyDto} from "../types/SemanticSearchPropertyDto";

export const AI_ASSISTANT_AUTH_CUSTOM_LABEL = "ai_assistant";

type AiAssistantAction = "open" | "close";
type AiAssistantChatAction = "click" | "fill" | "submit";
type AiAssistantCtaAction = "click" | "view";
type AiAssistantOfferAction = "view" | "select";

const getPropertyCity = (property: SemanticSearchPropertyDto): string => {
    const stats = property.offer.region.stats;

    return stats?.region_type_city?.name || stats?.region_type_town?.name || "na";
};

export const hitAiAssistant = (eventAction: AiAssistantAction) => {
    hitGoogleTagManager({
        event: "ai_assistant",
        event_action: eventAction
    });
};

export const hitAiAssistantChat = (eventAction: AiAssistantChatAction) => {
    hitGoogleTagManager({
        event: "ai_assistant_chat",
        event_action: eventAction
    });
};

export const hitAiAssistantBadge = (eventLabel: string) => {
    hitGoogleTagManager({
        event: "ai_assistant_badge",
        event_action: "click",
        event_label: eventLabel
    });
};

export const hitAiAssistantOffer = (eventAction: AiAssistantOfferAction, property: SemanticSearchPropertyDto) => {
    hitGoogleTagManager({
        event: "ai_assistant_offer",
        event_action: eventAction,
        event_category: property.offer.vendor.name,
        event_category2: property.offer.name,
        event_category3: getPropertyCity(property)
    });
};

export const hitAiAssistantOffers = (eventLabel: string, regionIds: number[]) => {
    hitGoogleTagManager({
        event: "ai_assistant_offers",
        event_action: "click",
        event_label: eventLabel,
        event_category: regionIds
    });
};

export const hitAiAssistantCta = (eventAction: AiAssistantCtaAction, eventLabel: "Załóż konto" | "Zaloguj się") => {
    hitGoogleTagManager({
        event: "ai_assistant_cta",
        event_action: eventAction,
        event_label: eventLabel
    });
};
